import React from 'react'
import styled, { keyframes } from 'styled-components'

import Icon from '../utilities/Icon'

const fade = keyframes`
    0%,100% { opacity: 0 }
    50% { opacity: 1 }
`

const lightning = keyframes`
    45% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    55% {
        opacity: 0;
    }
`

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  > div {
    position: absolute;

    opacity: 1;
    //animation: ${fade} 2s infinite;
  }

  .hide {
    opacity: 0;
  }

  .star1 {
    top: calc(532 / 720 * 100%);
    left: calc(56 / 1440 * 100%);


    //animation: ${lightning} 0.8s linear infinite;
  }
  .star2 {
    top: calc(41 / 720 * 100%);
    left: calc(141 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star3 {
    top: calc(597 / 720 * 100%);
    left: calc(232 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star4 {
    top: calc(176 / 720 * 100%);
    left: calc(237 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star5 {
    top: calc(314 / 720 * 100%);
    left: calc(292 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star6 {
    top: calc(23 / 720 * 100%);
    left: calc(339 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star7 {
    top: calc(460 / 720 * 100%);
    left: calc(436 / 1440 * 100%);

    //animation: ${lightning} 1.2s linear infinite;
  }
  .star8 {
    top: calc(80 / 720 * 100%);
    left: calc(638 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star9 {
    top: calc(113 / 720 * 100%);
    left: calc(666 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star10 {
    top: calc(481 / 720 * 100%);
    left: calc(737 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star11 {
    top: calc(284 / 720 * 100%);
    left: calc(761 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star12 {
    top: calc(160 / 720 * 100%);
    left: calc(784 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  /* .star13 {
  top: calc(230 / 720 * 100%);
  left: calc(9170 / 1440 * 100%);
} */
  .star14 {
    top: calc(279 / 720 * 100%);
    left: calc(835 / 1440 * 100%);

    //animation: ${lightning} 0.6s linear infinite;
  }
  .star15 {
    top: calc(230 / 720 * 100%);
    left: calc(917 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star16 {
    top: calc(417 / 720 * 100%);
    left: calc(977 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star17 {
    top: calc(15 / 720 * 100%);
    left: calc(1044 / 1440 * 100%);

    //animation: ${lightning} 0.9s linear infinite;
  }
  .star18 {
    top: calc(137 / 720 * 100%);
    left: calc(1091 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star19 {
    top: calc(576 / 720 * 100%);
    left: calc(1173 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star20 {
    top: calc(381 / 720 * 100%);
    left: calc(1252 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star21 {
    top: calc(702 / 720 * 100%);
    left: calc(1317 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star22 {
    top: calc(137 / 720 * 100%);
    left: calc(1091 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star23 {
    top: calc(207 / 720 * 100%);
    left: calc(1346 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star24 {
    top: calc(177 / 720 * 100%);
    left: calc(1403 / 1440 * 100%);


    //animation: ${lightning} 1.5s linear infinite;
  }
  .star25 {
    top: calc(530 / 720 * 100%);
    left: calc(1408 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star26 {
    top: calc(443 / 720 * 100%);
    left: calc(303 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star27 {
    top: calc(612 / 720 * 100%);
    left: calc(877 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
  .star28 {
    top: calc(239 / 720 * 100%);
    left: calc(1111 / 1440 * 100%);

    animation-delay: ${Math.random() * 4 + 0.5}s;
    animation-duration: ${Math.random() * 2 + 0.5}s;
  }
`

const Stars = () => (
  <Container>
    <div className="star1">
      <Icon name="fill60" />
    </div>
    <div className="star2">
      <Icon name="fill11" />
    </div>
    <div className="star3">
      <Icon name="fill17" />
    </div>
    <div className="star4">
      <Icon name="fill13" />
    </div>
    <div className="star5">
      <Icon name="fill17" />
    </div>
    <div className="star6">
      <Icon name="fill5" />
    </div>
    <div className="star7">
      <Icon name="fill60" />
    </div>
    <div className="star8">
      <Icon name="fill21" />
    </div>
    <div className="star9">
      <Icon name="fill17" />
    </div>
    <div className="star10">
      <Icon name="fill9" />
    </div>
    <div className="star11">
      <Icon name="fill3" />
    </div>
    <div className="star12">
      <Icon name="fill17" />
    </div>
    <div className="star13">
      <Icon name="fill3" />
    </div>
    <div className="star14">
      <Icon name="fill60" />
    </div>
    <div className="star15">
      <Icon name="fill7" />
    </div>
    {/* <div className="star16">
      <Icon name="fill23" />
    </div>
    <div className="star17">
      <Icon name="fill60" />
    </div> */}
    <div className="star18">
      <Icon name="fill19" />
    </div>
    {/* <div className="star19">
      <Icon name="fill25" />
    </div> */}
    <div className="star20">
      <Icon name="fill1" />
    </div>
    {/* <div className="star21">
      <Icon name="fill25" />
    </div> */}
    <div className="star22">
      <Icon name="fill23" />
    </div>
    {/* <div className="star23">
      <Icon name="fill3" />
    </div> */}
    <div className="star24">
      <Icon name="fill60" />
    </div>
    <div className="star25">
      <Icon name="fill3" />
    </div>
    {/* <div className="star26">
      <Icon name="fillshape" />
    </div> */}
    <div className="star27">
      <Icon name="fillshape1" />
    </div>
    {/* <div className="star28">
      <Icon name="fillshape2" />
    </div> */}
  </Container>
)

export default Stars



// WEBPACK FOOTER //
// ./src/components/Stars.js